import apiClient from "../../../services/apiClient";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// List contributions
export const fetchContributions = createAsyncThunk(
  'saving/fetchContributions',
  async ({ canvasId, savingId }, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(`/canvas/${canvasId}/saving/${savingId}/contributions`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Add contribution
export const addContribution = createAsyncThunk(
  'saving/addContribution',
  async ({ canvasId, savingId, amount, date }, { rejectWithValue }) => {
    try {
      const res = await apiClient.post(`/canvas/${canvasId}/saving/${savingId}/contributions`, { amount, date });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Edit contribution
export const editContribution = createAsyncThunk(
  'saving/editContribution',
  async ({ canvasId, contributionId, amount, date }, { rejectWithValue }) => {
    try {
      const res = await apiClient.patch(`/canvas/${canvasId}/saving/contributions/${contributionId}`, { amount, date });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// Delete contribution
export const deleteContribution = createAsyncThunk(
  'saving/deleteContribution',
  async ({ canvasId, contributionId }, { rejectWithValue }) => {
    try {
      await apiClient.delete(`/canvas/${canvasId}/saving/contributions/${contributionId}`);
      return contributionId;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const savingOverview = createAsyncThunk(
  'saving/getOverveiw',
  async ({ canvasId }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `/canvas/${canvasId}/saving/overview`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || error);
    }
  }

)
//Fetch Saving THUNK
export const fetchSavings = createAsyncThunk(
  'saving/fetchSavings',
  async ({ canvasId, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `/canvas/${canvasId}/saving?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message || error);
    }
  }
);
//Create
export const createSaving = createAsyncThunk(
  'saving/create',
  async({canvasId, savingData}, {rejectWithValue})=>{
    try{
     
      const response = await apiClient.post(
        `/canvas/${canvasId}/saving`,savingData)
      return response.data
    }catch(error){
      return rejectWithValue(error|| error?.message)
    }

  }
);
//Update
export const updateSaving = createAsyncThunk(
  'saving/update',
  async({canvasId, savingId, savingData}, {rejectWithValue})=>{
    try{  
    const response = await apiClient.patch(
        `canvas/${canvasId}/saving/${savingId}`,
        savingData)
      return response.data
    }catch(err){
      return rejectWithValue(err|| err?.message)
    }
  }
)
//delte
export const deleteSaving = createAsyncThunk(
  'saving/delete',
  async({canvasId, savingId}, {rejectWithValue})=>{
    try{  
    const response = await apiClient.delete(
        `canvas/${canvasId}/saving/${savingId}`)
      return response.data
    }catch(err){
      return rejectWithValue(err || err?.message)
    }

  }
)

export const uploadSavings = createAsyncThunk(
  'saving/upload',
  async ({ canvasId, file }, { rejectWithValue }) => {
      try {
        if (!(file instanceof File)) {
          throw new Error(`Expected File object but got ${typeof file}: ${JSON.stringify(file)}`);
        }
        const formData = new FormData();
        formData.append('file', file);
  
        const response = await apiClient.post(
          `/canvas/${canvasId}/saving/upload`,
          formData);
        return response.data;
    }catch(err){
      return rejectWithValue(err || err?.message)
    }
  }
)

const savingSlice = createSlice({
    name:'saving',
    initialState:{
        savings: [],
        pagination: { total: 0, page: 1, pages: 1 },
        loading: false,
        error: null,
        overivew:null,
        contributions: [],
        contributionsLoading: false,
    },
    reducers:{
      resetSavingError: (state) => {
          state.error = null;
      },
    },
    extraReducers: (builder)=>{
      builder
      .addCase(fetchSavings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavings.fulfilled, (state, action) => {
        state.loading = false;
        state.savings = action.payload.savings || action.payload.items || [];
        state.pagination = {
          total: action.payload.total,
          page: action.payload.page,
          pages: action.payload.pages,
        };
      })
      .addCase(fetchSavings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createSaving.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSaving.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        state.savings.push(action.payload);
      })
      .addCase(createSaving.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSaving.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSaving.fulfilled, (state, action) => {
        state.loading = false;
        const idx = state.savings.findIndex(s => s._id === action.payload._id);
        if (idx !== -1) state.savings[idx] = action.payload;
      })
      .addCase(updateSaving.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete
      .addCase(deleteSaving.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSaving.fulfilled, (state, action) => {
        state.loading = false;
        state.savings = state.savings.filter(s => s._id !== action.payload);
      })
      .addCase(deleteSaving.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadSavings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadSavings.fulfilled, (state, action) => {
        state.loading = false;
        state.savings = [...state.savings, ...(action.payload?.savings || action.payload?.items || [])];
      })
      .addCase(uploadSavings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(savingOverview.fulfilled, (state, action)=>{
        state.loading =false;
        state.overview = action.payload;
      })
      .addCase(fetchContributions.pending, (state) => {
        state.contributionsLoading = true;
      })
      .addCase(fetchContributions.fulfilled, (state, action) => {
        state.contributionsLoading = false;
        state.contributions = action.payload;
      })
      .addCase(fetchContributions.rejected, (state) => {
        state.contributionsLoading = false;
        state.contributions = [];
      })
      .addCase(addContribution.fulfilled, (state, action) => {
        state.contributions.unshift(action.payload);
      })
      .addCase(editContribution.fulfilled, (state, action) => {
        state.contributions = state.contributions.map(c =>
          c._id === action.payload._id ? action.payload : c
        );
      })
      .addCase(deleteContribution.fulfilled, (state, action) => {
        state.contributions = state.contributions.filter(c => c._id !== action.payload);
      });
    }
    
})
export const { resetSavingError } = savingSlice.actions;
export const selectSavings = state => state.saving.savings;
export const selectSavingLoading = state => state.saving.loading;
export const selectSavingPagination = state => state.saving.pagination;
export const selectSavingOverview = state => state.saving.overview;
export const selectContributions = state => state.saving.contributions;
export const selectContributionsLoading = state => state.saving.contributionsLoading;
export default savingSlice.reducer;